//CORE
import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  ViewEncapsulation,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";

//SERVICE
import { CoursePageService } from "../services/course-page.service";
import { AppService } from "../services/app.service";

//MODEL
import { LessonDetail } from "../model/lesson_detail";
import { ModalInfo } from "../model/modal_info";
import { Topbar } from "../model/topbar";

import { environment } from "../../environments/environment";
import { Badge } from "../model/badge";
import { ProfilePageService } from "../services/profile-page.service";
import { Avatar } from "../model/avatar";
import { DidacticObject } from "../model/didactic_object";
import { CourseLesson } from "../model/course_lesson";
import { ModalScorm } from "../model/modal_scorm";
import { SwiperComponent } from "angular2-useful-swiper";
import { SharedService } from "../services/shared.service";

import * as $ from "jquery";
import * as Parallax from "parallax-js";

declare var window: any;
declare var ssla: any;
declare var sslaConfig: any;
declare var Parallax: any;

@Component({
  selector: "app-course-page",
  templateUrl: "./course-page.component.html",
  styleUrls: ["./course-page.component.css"],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [CoursePageService, ProfilePageService],
})
export class CoursePageComponent implements OnInit {
  @ViewChild("swiperLessons") swiperLessons?: SwiperComponent;
  @ViewChild("swiperAvatars") swiperAvatars: SwiperComponent;

  @ViewChild("iframeContainer") iframeContainer: ElementRef;

  // Utilizzatti per l'effetto parallasse sui singoli OD sulla mappa
  @ViewChild("mainSection") mainSection: ElementRef;
  @ViewChildren("scene") scenes: QueryList<ElementRef>;

  // Contiene il riferimento al corso selezionato
  header: Topbar;

  // Contiene la lista dei corsi
  headerList: Topbar[];

  // Utilizzato per il cambio corso
  currentCourseId: number;

  // Utilizzate per verificare se dopo l'esecuzione di uno scorm si è saliti di livello
  currentLevel: number;
  nextLevel: boolean;

  course_lessons: CourseLesson[] = [];
  course_lessons_array = [];
  od_lesson: Array<DidacticObject[]> = [];
  didacticObjectsInfo: Array<ModalInfo[]> = [];

  // Lezione corrente
  current_lesson: LessonDetail;
  indexCurrentLesson: number;
  isLocked: Array<boolean> = [];

  // Utilizzate per mostrare la modale contenente info su od
  modalInfo: ModalInfo;
  showModalOd = false;

  // Sezione relativa alla modale che si apre dopo la conclusione di uno Scorm
  showModalScorm = false;
  playScorm = false;
  modalScorm: ModalScorm;
  scormData: JSON;
  scormFailed = false;

  language: any;

  key: string = localStorage.getItem("key");
  browser = "";

  // Lista di tutti gli avatar filtrati
  allAvatars: Avatar[];
  shouldShowAvatarsPopup = false;
  shouldShowAvatarConfirmPopup = false;
  // avatar corrente selezionato
  selectedAvatar: Avatar = null;
  // ID dell'avatar di default
  defaultEmptyIdAvatar = 0;
  // configurazione swiper per gli avatar
  swiperConfigAvatar = {
    // Optional parameters
    speed: 1000,
    direction: "horizontal",
    parallax: true,
    loop: false,
    centeredSlides: true,
    slidesPerView: "auto",
    slideToClickedSlide: true,
    grabCursor: true,
    // If we need pagination
    navigation: {
      nextEl: ".swiper-container-avatar .swiper-button-next",
      prevEl: ".swiper-container-avatar .swiper-button-prev",
    },
    on: {
      slideChange: (swiper) => {
        this.selectedAvatar =
          this.allAvatars.length > 0
            ? this.allAvatars[swiper.activeIndex]
            : null;
      },
    },
  };

  selectedLesson: CourseLesson;
  selectedDidacticObject: DidacticObject;

  swiperBackgrounds: Array<{
    elemRef: HTMLElement;
    incrementalTranslation: number;
  }> = [];

  startLessonsSwiper = false;
  swiperConfigLessons = {
    // Optional parameters
    speed: 1000,
    direction: "horizontal",
    parallax: false,
    loop: false,
    preventClicks: true,
    centeredSlides: true,
    slidesPerView: 1,
    // Responsive breakpoints
    breakpoints: {
      600: {
        centerInsufficientSlides: true,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1400: {
        centerInsufficientSlides: true,
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-navigation-container .swiper-button-next",
      prevEl: ".swiper-navigation-container .swiper-button-prev",
    },
  };

  shouldShowIntroVideo = false;
  showMenuNotification = false;
  seeButton: boolean = true;

  relearnit_base_url = environment.relearnit_base_url;
  scrollButtonList: Array<Element>;

  currentOdId: any = null;
  startScormDate: Date | null = null;

  constructor(
    private coursePageService: CoursePageService,
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    protected ref: ChangeDetectorRef,
    private sharedService: SharedService,
    private profileService: ProfilePageService
  ) {
    this.coursePageService = coursePageService;

    // Array con i corsi e le relazioni corsi <=> utente
    this.headerList = JSON.parse(localStorage.getItem("headerList"));

    // Contiene il corso selezionato
    this.header = JSON.parse(localStorage.getItem("header"));
    if (this.header == null) {
      this.router.navigate(["/homepage"]);
      return;
    }

    // this.language = JSON.parse(localStorage.getItem('geolocation'));
  }

  ngOnInit() {
    this.sharedService.headerUpdated.subscribe(async (headerList: Topbar[]) => {
      this.headerList = headerList;
      for (const header of this.headerList) {
        if (header.course_id == this.currentCourseId) {
          this.header = header;
          break;
        }
      }
      localStorage.setItem("header", JSON.stringify(this.header));

      if (this.header == null) {
        await this.router.navigate(["/homepage"]);
        return;
      }
    });

    // if (this.header != null && this.header.id_avatar == this.defaultEmptyIdAvatar) {
    //   // piccolo delay per far vedere l'animazione della comparsa del video
    //   setTimeout(() => {
    //     this.startCourse();
    //     this.shouldShowIntroVideo = true;
    //   }, 300);
    // } else {
    //   this.startCourse();
    //   this.shouldShowIntroVideo = false;
    // }

    // inizializza le informazioni sul corso, le sue lezioni e Didactic Objects
    this.getCourseDetails();

    // Prende il nome del browser
    this.browser = this.getBrowser["name"];
    // Prende il livello attuale
    this.currentLevel = this.header.level;
    // Prende l'ID del corso attuale
    this.currentCourseId = this.header.course_id;
    // Setta avanzamento del livello a false
    this.nextLevel = false;

    window.RELEARN_SUPPORT = {
      userId: -1,
      courseId: -1,
      odId: -1,
      completed: false,
      isReloading: false,
    };

    window.RELEARN_IFRAME = {
      reset: () => {
        window.RELEARN_SUPPORT.userId = -1;
        window.RELEARN_SUPPORT.courseId = -1;
        window.RELEARN_SUPPORT.odId = -1;
        window.RELEARN_SUPPORT.completed = false;
        window.RELEARN_SUPPORT.isReloading = false;
      },
      exit: () => {
        //$("#jca_course_player").attr("src", "");
        //
        // Se @sessionTime non è valido, allora inserire in valore valido
        // corrispondente alla differenza dell'inizio dello scorm con la fine
        // in formato HH:MM:SS
        console.log("Inside 'Exit'");
        if (
          ssla.ssla.scorm.scosData.sessionTime === "" ||
          ssla.ssla.scorm.scosData.sessionTime === "00:00:00" ||
          ssla.ssla.scorm.scosData.sessionTime === "0000:00:00"
        ) {
          var closeScormDate = new Date();
          console.log(
            "sessionTime is not valid, its value is: " +
              ssla.ssla.scorm.scosData.sessionTime
          );

          var difference =
            (closeScormDate.getTime() - this.startScormDate.getTime()) / 1000;
          var dateHH = Math.floor(difference / 3600);
          var hourString = dateHH < 10 ? `0${String(dateHH)}` : dateHH;
          var dateMM = Math.floor((difference % 3600) / 60);
          var minuteString = dateMM < 10 ? `0${String(dateMM)}` : dateMM;
          var dateSS = Math.floor(difference % 60);
          var secondString = dateSS < 10 ? `0${String(dateSS)}` : dateSS;
          var scormId = ssla.ssla.scorm.scosData.currentScoId;
          if (scormId)
            ssla.ssla.scorm.scosData.scos[scormId].set(
              "cmi.core.session_time",
              `${hourString}:${minuteString}:${secondString}`
            );
        }
        $(this.iframeContainer.nativeElement).removeClass("scorm");
        this.scormData = ssla.ssla.scorm.scosData.exportData(ssla.ssla.config);
        console.log(
          "The new sessionTime value is: " +
            `${hourString}:${minuteString}:${secondString}`
        );

        this.playScorm = false;
        if (window.RELEARN_SUPPORT.isReloading) {
          window.RELEARN_SUPPORT.isReloading = false;
          ssla.finish();
        } else {
          ssla.finish();
          if (
            !window.RELEARN_SUPPORT.completed &&
            (this.scormData["status"] == "completed" ||
              this.scormData["status"] == "passed")
          ) {
            // this.getAndShowModalAfterComplete(
            //   this.header.user_id,
            //   this.header.course_id,
            //   window.RELEARN_SUPPORT.odId,
            //   this.scormData["score"]
            // );
          }
        }
        this.closeFullscreen();
        location.reload();
      },
      close: () => {
        //$("#jca_course_player").attr("src", "");

        // Se @sessionTime non è valido, allora inserire in valore valido
        // corrispondente alla differenza dell'inizio dello scorm con la fine
        // in formato HH:MM:SS
        console.log("Inside 'Close'");

        if (
          ssla.ssla.scorm.scosData.sessionTime === "" ||
          ssla.ssla.scorm.scosData.sessionTime === "00:00:00" ||
          ssla.ssla.scorm.scosData.sessionTime === "0000:00:00"
        ) {
          var closeScormDate = new Date();
          console.log(
            "sessionTime is not valid, its value is: " +
              ssla.ssla.scorm.scosData.sessionTime
          );

          var difference =
            (closeScormDate.getTime() - this.startScormDate.getTime()) / 1000;
          var dateHH = Math.floor(difference / 3600);
          var hourString = dateHH < 10 ? `0${String(dateHH)}` : dateHH;
          var dateMM = Math.floor((difference % 3600) / 60);
          var minuteString = dateMM < 10 ? `0${String(dateMM)}` : dateMM;
          var dateSS = Math.floor(difference % 60);
          var secondString = dateSS < 10 ? `0${String(dateSS)}` : dateSS;
          var scormId = ssla.ssla.scorm.scosData.currentScoId;
          if (scormId)
            ssla.ssla.scorm.scosData.scos[scormId].set(
              "cmi.core.session_time",
              `${hourString}:${minuteString}:${secondString}`
            );
        }
        console.log(
          "The new sessionTime value is: " +
            `${hourString}:${minuteString}:${secondString}`
        );

        $(this.iframeContainer.nativeElement).removeClass("scorm");
        this.scormData = ssla.ssla.scorm.scosData.exportData(ssla.ssla.config);
        this.playScorm = false;
        if (window.RELEARN_SUPPORT.isReloading) {
          window.RELEARN_SUPPORT.isReloading = false;
          ssla.finish();
        } else {
          ssla.finish();
          if (
            !window.RELEARN_SUPPORT.completed &&
            (this.scormData["status"] == "completed" ||
              this.scormData["status"] == "passed")
          ) {
            /*this.getAndShowModalAfterComplete(
              this.header.user_id,
              this.header.course_id,
              window.RELEARN_SUPPORT.odId,
              this.scormData["score"]
            );*/
          }
        }
        this.closeFullscreen();
        location.reload();
      },
      reload: () => {
        console.log("Trigged: reload");

        const iframe = $("#jca_course_player").get(0) as HTMLIFrameElement;
        iframe.contentWindow.location.reload(true);
        window.RELEARN_SUPPORT.isReloading = true;
      },
    };
  }

  ngAfterViewInit() {
    // Effetto parallasse sui singoli OD sulla mappa
    let mainSection = <HTMLElement>this.mainSection.nativeElement;
    mainSection.classList.add("loaded");
    // Prima chiamata
    this.scenes.forEach((elem, index) => {
      this.addParallax(elem);
    });

    // Chiamata ad ogni cambiamento
    this.scenes.changes.subscribe(() => {
      this.scenes.forEach((elem, index) => {
        this.addParallax(elem);
      });
    });
  }

  // Effetto parallasse
  addParallax(elem) {
    new Parallax(elem.nativeElement, {
      relativeInput: true,
      hoverOnly: true,
    });
  }

  // prendi ed aggiorna le informazioni sul corso, le sue lezioni e Didactic Objects
  getCourseDetails() {
    this.od_lesson = [];
    this.didacticObjectsInfo = [];
    this.course_lessons_array = [];

    // Sottoscrizione alla selezione del corso con l'id del corso, la X-API-KEY e l'id dell'utente
    this.coursePageService
      .getLessons(this.header.course_id, this.key, this.header.user_id)
      .subscribe((result) => {
        // Restituisce un array contenente info sulle lezioni del corso:
        // id_lesson, lesson_order, od_number, status_lesson
        this.course_lessons = result;
        this.course_lessons.sort((a, b) => a.lesson_order - b.lesson_order);

        this.coursePageService
          .getLessonDetail(
            this.header.user_id,
            this.header.course_id,
            this.header.id_current_lesson,
            this.key
          )
          .subscribe(async (result) => {
            // Restituisce un array contenente info sulla lezione corrente:
            // completed, lesson_description, lesson_goal_of_day: "100%", lesson_max_overrun_limit,
            // lesson_max_recuperation_limit, lesson_name, remaining
            this.current_lesson = result;
            if (this.course_lessons) {
              console.log(this.course_lessons);
              for (const cl of this.course_lessons) {
                const idLesson = cl["id_lesson"];
                // Array con gli ID delle lezioni
                this.course_lessons_array.push(idLesson);
                await this.getOdLesson(
                  this.header.user_id,
                  this.header.course_id,
                  idLesson
                );
              }

              this.course_lessons_array.forEach((element, index) => {
                console.log(this.header.id_current_lesson);
                if (this.header.id_current_lesson >= element) {
                  localStorage.setItem(
                    "indexCurrentLesson",
                    JSON.stringify(index)
                  );
                  this.indexCurrentLesson = JSON.parse(
                    localStorage.getItem("indexCurrentLesson")
                  );
                }
              });
            }

            // Setta il numero di OD visualizzabili sullo slide delle lezioni della pagina in base alla grandezza grandezza
            this.swiperConfigLessons.breakpoints[600].slidesPerView =
              (this.didacticObjectsInfo[0] != undefined &&
                this.didacticObjectsInfo[0] != null &&
                this.didacticObjectsInfo[0].length) >= 3
                ? 3
                : this.didacticObjectsInfo[0].length;

            // Inizializza lo Slide delle lezioni
            this.startLessonsSwiper = true;

            // SlideTo il primo OD non iniziato o non completato
            setTimeout(() => {
              var firstIncompleteOd = this.didacticObjectsInfo[0].findIndex(
                (od) =>
                  od.do_status === null ||
                  od.do_status === "incomplete" ||
                  od.do_status === "failed"
              );
              this.swiperLessons.Swiper.slideTo(firstIncompleteOd, 1000);
            }, 500);
            // window.addEventListener("resize", () => {
            //   this.initSwiper();
            // });
            this.ref.detectChanges();
          });
      });
  }

  // initSwiper() {
  //   if (this.swiperLessons.Swiper != null) {
  //     this.swiperLessons.Swiper.init();

  //     // this.swiperLessons.Swiper
  //   }
  // }

  async getHeader() {
    this.headerList = await this.appService
      .getHeader(this.header.user_id, this.key)
      .toPromise();
    for (const header of this.headerList) {
      if (header.course_id == this.currentCourseId) {
        this.header = header;
        break;
      }
    }

    localStorage.setItem("headerList", JSON.stringify(this.headerList));
    localStorage.setItem("header", JSON.stringify(this.header));

    if (this.header == null) {
      await this.router.navigate(["/homepage"]);
      return;
    }

    if (this.currentLevel != this.header.level) {
      this.currentLevel = this.header.level;
      this.nextLevel = true;
    } else {
      this.nextLevel = false;
    }
  }

  // mostra il popup di conferma della scelta dell'avatar
  showAvatarConfirmPopup() {
    this.shouldShowAvatarConfirmPopup = true;
  }

  // nascondi il popup di conferma della scelta dell'avatar
  closeAvatarConfirmPopup() {
    this.shouldShowAvatarConfirmPopup = false;
  }

  // aggiorna l'avatar per il corso selezionato
  updateCourseAvatar(): void {
    if (this.selectedAvatar != null) {
      // aggiorna l'avatar dell'utente con quello scelto
      this.profileService
        .changeAvatar(
          this.header.user_id,
          this.header.course_id,
          this.selectedAvatar.id,
          this.key
        )
        .subscribe(async () => {
          // aggiorna l'header
          await this.getHeader();
          // nascondi i popup di selezione avatar
          this.shouldShowAvatarsPopup = false;
          this.shouldShowAvatarConfirmPopup = false;

          // fai partire il corso
          this.startCourse();
        });
    }
  }

  // prendi e mostra tutti gli avatar
  getAndShowAvatarsPopup() {
    this.shouldShowAvatarsPopup = true;
    // prendi tutti gli avatar
    this.profileService.getAllAvatars(this.key).subscribe((result) => {
      // mostra tutti gli avatar eccetto quello di default con ID 0
      // e nascondi tutti gli avatar con livelli avanzati
      this.allAvatars = result.filter(
        (value) => value.id != this.defaultEmptyIdAvatar && value.id % 50 == 1
      );
      this.selectedAvatar =
        this.allAvatars.length > 0 ? this.allAvatars[0] : null;
    });
  }

  // funzione per far iniziare il corso
  startCourse() {
    // controlla se l'utente deve ancora scegliere l'avatar per il corso selezionato.
    // Se l'avatar ha ID 0, allora vuol dire che l'utente ancora non ha scelto l'avatar per il corso selezionato
    if (
      this.header != null &&
      this.header.id_avatar == this.defaultEmptyIdAvatar
    ) {
      this.getAndShowAvatarsPopup();
    }
  }

  // seleziona il Didactic Object
  selectDidacticObject(indexLesson: number, indexDidacticObject: number) {
    if (!this.didacticObjectsInfo[indexLesson][indexDidacticObject].lockStart) {
      this.selectedLesson = this.course_lessons[indexLesson];
      this.selectedDidacticObject =
        this.od_lesson[indexLesson][indexDidacticObject];
      this.modalInfo =
        this.didacticObjectsInfo[indexLesson][indexDidacticObject];
      this.showModalOd = true;
      this.canSeeButton("startScormButton");
      var mainEl = document.querySelector(".main");
      setTimeout(() => {
        mainEl.classList.add("show-lo-modal");
      }, 100);
    }
  }

  // ottieni la lista di tutti i Didactic Object di una lezione
  async getOdLesson(user_id: number, id_course: number, id_lesson: number) {
    var result = await this.coursePageService
      .getOdLesson(user_id, id_course, id_lesson, this.key)
      .toPromise();
    // ordina i Didactic Object secondo il display order
    result.sort((a, b) => a.display_order - b.display_order);
    this.od_lesson.push(result);

    const infos = [];
    for (const od of result) {
      const info = await this.getModalOdInfo(id_course, user_id, od);
      infos.push(info);
    }
    this.didacticObjectsInfo.push(infos);
    console.log("OD INFOOOO:", this.didacticObjectsInfo);
  }

  // Mostra il video introduttivo nuovamente
  showIntroVideoAgain($event) {
    setTimeout(() => {
      this.shouldShowIntroVideo = true;
    }, 300);
  }

  closeIntroVideoCourse() {
    let videoElement = document.querySelector(
      ".intro-video"
    ) as HTMLVideoElement;
    videoElement ? videoElement.pause() : null;
    this.shouldShowIntroVideo = false;
    this.canSeeButton("avatarButton");
  }

  // Calcola se il pulsante per proseguire è a vista nella viewport
  canSeeButton(buttonId: string) {
    setTimeout(() => {
      this.seeButton =
        document.querySelector(`#${buttonId}`).getBoundingClientRect().top <
        window.innerHeight;
    }, 400);
  }

  // prendi e visualizza il modale con le informazioni del Didactic Object selezionato
  async getModalOdInfo(
    idCourse: number,
    idUser: number,
    didacticObject: DidacticObject
  ): Promise<ModalInfo> {
    let isDone = false;
    let lockStart = false;

    if (
      didacticObject.status === "completed" ||
      didacticObject.status === "passed"
    ) {
      isDone = true;
    } else if (
      didacticObject.status !== "failed" &&
      didacticObject.status !== "incomplete"
    ) {
      // controlla se questo Didactic Object richiede una serie di Didactic Object obbligatori
      // prima di poter essere abilitato.
      if (
        didacticObject.preparatory_course != null &&
        didacticObject.preparatory_course.trim() != "" &&
        didacticObject.preparatory_course.trim() != "0"
      ) {
        const requiredDidacticObjects =
          didacticObject.preparatory_course.split(";");
        for (let i = 0; i < requiredDidacticObjects.length && !lockStart; i++) {
          for (const lesson of this.od_lesson) {
            for (const od of lesson) {
              if (od.id_od.toString() == requiredDidacticObjects[i]) {
                // se troviamo almeno un Didactic Object precedente che non è stato
                // ancora completato correttamente, allora blocchiamo il didacticObject
                // che stiamo valutando in questa chiamata di funzione.
                lockStart = !(
                  od.status == "completed" || od.status == "passed"
                );
                break;
              }
            }
            if (lockStart) {
              break;
            }
          }
        }
      }
    }

    const result = await this.coursePageService
      .getModalOdInfo(idCourse, idUser, didacticObject.id_od, this.key)
      .toPromise();

    const modalInfo = result[0];
    modalInfo.isDone = isDone;
    modalInfo.lockStart = lockStart;

    if (result[1] && result[1].badges) {
      modalInfo.badges = result[1].badges;
    } else {
      modalInfo.badges = null;
    }

    return modalInfo;
  }

  // chiudi il modale con le informazioni del Didactic Object
  closeModalOdInfo() {
    var mainEl = document.querySelector(".main");
    mainEl.classList.remove("show-lo-modal");
    $('body').css('overflow-y', 'scroll');
    this.showModalOd = false;
  }

  // prendi e mostra le informazioni di un corso dopo il suo eventuale completamento o fallimento
  getAndShowModalAfterComplete(
    user_id: number,
    course_id: number,
    id_od: number,
    score: number
  ): void {
    this.coursePageService
      .getModalAfterComplete(user_id, course_id, id_od, score, this.key)
      .subscribe(async (result) => {
        this.modalScorm = result[0];
        this.scormFailed = !(
          this.modalScorm.status == "completed" ||
          this.modalScorm.status == "passed"
        );
        this.playScorm = false;
        if (result[1] && result[1].badges) {
          this.modalScorm.badges = result[1].badges;
        } else {
          this.modalScorm.badges = null;
        }

        // aggiorna le informazioni dell'header
        await this.getHeader();

        this.showModalScorm = true;
        this.canSeeButton("resultScormButton");

        this.showMenuNotification =
          this.modalScorm.score_obtained > 0 ||
          this.modalScorm.progress_percent > 0 ||
          (this.modalScorm.badges != null &&
            this.modalScorm.badges.length > 0) ||
          this.nextLevel;

        if (
          this.modalScorm.status == "completed" ||
          this.modalScorm.status == "passed"
        ) {
          setTimeout(() => {
            this.course_lessons_array.forEach((element, index) => {
              if (this.header.id_current_lesson == element) {
                localStorage.setItem(
                  "indexCurrentLesson",
                  JSON.stringify(index)
                );
              }
            });
          }, 500);
        }

        this.getCourseDetails();

        this.ref.detectChanges();
      });
  }

  closeModalScorm() {
    this.showModalScorm = false;
  }

  getBrowser() {
    let ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: "IE",
        version: tem[1] || "",
      };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return {
          name: "Opera",
          version: tem[1],
        };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1],
    };
  }

  startScorm(
    courseId: number,
    userId: number,
    userName: string,
    odId: number,
    status: string,
    scormName: string
  ): void {
    window.initSsla();

    window.RELEARN_SUPPORT.userId = userId;
    window.RELEARN_SUPPORT.odId = odId;
    window.RELEARN_SUPPORT.courseId = courseId;
    window.RELEARN_SUPPORT.start_at = new Date();
    window.RELEARN_SUPPORT.end_at = new Date();
    window.RELEARN_SUPPORT.completed = status === "completed";

    var mainEl = document.querySelector(".main");

    const modalPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        mainEl.classList.add("show-lo-modal");
        $('body').css('overflow-y', 'hidden');
        resolve(true);
      }, 100);
    });
    
    modalPromise
      .then(() => {
        setTimeout(() => $("#frame-here").addClass("scorm"), 100)      
    })

    this.playScorm = true;
    this.currentOdId = odId;

    console.log(scormName);

    sslaConfig = {
      openContentIn: "inline",
      getMode: "browse",
      getDataAjaxMethod: "GET",
      autoLaunchFirstSco: true,
      returnToLastScoOnLaunch: false,
      saveDataOnCommit: false, //da controllare
      getDataUrl: environment.base_url + "Rest_Scorm/information/",
      getDataHeaders: {
        "X-API-KEY": this.key,
        "Access-Control-Allow-Origin": "*",
      },
      setDataUrl: environment.base_url + "Rest_Scorm/save/",
      setDataHeaders: {
        "X-API-KEY": this.key,
        "Content-Type": "application/json",
      },
      storageAllowCORS: false,
      storageUseWithCredentials: false,

      courseId: courseId,
      idOD: odId,
      studentId: userId,
      studentName: userName,
      executed: status,
      courseDirectory: "../" + scormName,
      /* courseDirectory: '../../assets/snai1', */
      exitAction: "custom",
      exitFn: () => {
        // Se @sessionTime non è valido, allora inserire in valore valido
        // corrispondente alla differenza dell'inizio dello scorm con la fine
        // in formato HH:MM:SS
        console.log("Inside 'exitFn'");

        if (
          ssla.ssla.scorm.scosData.sessionTime === "" ||
          ssla.ssla.scorm.scosData.sessionTime === "00:00:00" ||
          ssla.ssla.scorm.scosData.sessionTime === "0000:00:00"
        ) {
          var closeScormDate = new Date();
          console.log(
            "sessionTime is not valid, its value is: " +
              ssla.ssla.scorm.scosData.sessionTime
          );

          var difference =
            (closeScormDate.getTime() - this.startScormDate.getTime()) / 1000;
          var dateHH = Math.floor(difference / 3600);
          var hourString = dateHH < 10 ? `0${String(dateHH)}` : dateHH;
          var dateMM = Math.floor((difference % 3600) / 60);
          var minuteString = dateMM < 10 ? `0${String(dateMM)}` : dateMM;
          var dateSS = Math.floor(difference % 60);
          var secondString = dateSS < 10 ? `0${String(dateSS)}` : dateSS;
          var scormId = ssla.ssla.scorm.scosData.currentScoId;
          if (scormId)
            ssla.ssla.scorm.scosData.scos[scormId].set(
              "cmi.core.session_time",
              `${hourString}:${minuteString}:${secondString}`
            );
        }
        this.scormData = ssla.ssla.scorm.scosData.exportData(ssla.ssla.config);
        console.log(
          "The new sessionTime value is: " +
            `${hourString}:${minuteString}:${secondString}`
        );

        if (
          this.scormData["status"] == "completed" ||
          this.scormData["status"] == "passed"
        ) {
          this.getAndShowModalAfterComplete(
            this.header.user_id,
            this.header.course_id,
            odId,
            this.scormData["score"]
          );
          ssla.finish();
        } else {
          ssla.finish();
        }
        this.closeFullscreen();
      },
      closePopupMultiScoBehavior: "exit",
      closePopupSingleScoBehavior: "exit",
      popupWindowParams:
        "height=" + window.innerHeight + ",width=" + window.innerWidth + "",
    };

    ssla.start();
    this.startScormDate = new Date();

    this.closeModalOdInfo();
  }

  closeFullscreen() {
    if (document.exitFullscreen && document.fullscreenElement != null) {
      document.exitFullscreen();
    } else if (
      document.webkitExitFullscreen &&
      document.webkitFullscreenElement != null
    ) {
      document.webkitExitFullscreen();
    } else if (
      document["mozCancelFullScreen"] &&
      document["mozFullScreenElement"] != null
    ) {
      document["mozCancelFullScreen"]();
    } else if (document["msExitFullscreen"]) {
      document["msExitFullscreen"]();
    }
  }

  // Chiude lo scorm attivo tramite pulsante esterno
  async closeIframeByButton() {
    window.RELEARN_IFRAME.close();
  }

  sanitizeOdTitle(doTitle: string){
    let title = doTitle;
    title = title.replace('Amministratore - ', '');
    title = title.replace('amministratore - ', '');
    title = title.replace('Dipendenti - ', '');
    title = title.replace('dipendenti - ', '');
    title = title.replace('Negozio - ', '');
    title = title.replace('negozio - ', '');
    title = title.replace('PGS - ', '');
    title = title.replace('pgs - ', '');
    title = title.replace('VLT - ', '');
    title = title.replace('vlt - ', '');
    title = title.replace('Noleggiatore - ', '');
    title = title.replace('noleggiatore - ', '');
    title = title.replace('Snaipay PVR - ', '');
    title = title.replace('Dipendenti Snaitech - ', '');
    title = title.replace('dipendenti snaitech - ', '');
    title = title.replace('HR Amministratore - ', '');
    title = title.replace('hr amministratore - ', '');

    return title;
  }
}



// WEBPACK FOOTER //
// ./src/app/course-page/course-page.component.ts